import { post, patch, get } from 'axios';
import { AUTH_BASE_ENDPOINT } from './endpoints';
import { endpoints } from '@source/config';

const getQRCodeClientInfo = qid => {
  return get(`${AUTH_BASE_ENDPOINT}/_/v1/qrcode?qid=${qid}`, {
    ...endpoints.setting
  })
    .then(response => {
      const result = response.data ? response.data.data : null;
      return {
        meta: {
          status: 'success',
          error: ''
        },
        data: result
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `qrcode/getQRCodeClientInfo - ${error}`
        },
        data: null
      };
    });
};

const postQrCodeLogin = (qid, token) => {
  return post(
    `${AUTH_BASE_ENDPOINT}/_/v1/qrcode/auth`,
    {
      qid: qid
    },
    {
      ...endpoints.setting,
      headers: token && { Authorization: `Bearer ${token}` }
    }
  )
    .then(response => {
      const status = response.data.status;
      return {
        meta: {
          postStatus: status,
          postError: ''
        }
      };
    })
    .catch(error => {
      return {
        meta: {
          postStatus: 'error',
          postError: `qrcode/postQrCodeLogin - ${error}`
        }
      };
    });
};

const emailForgotPassword = ({ email = '', csrf = '' }) => {
  const body = { email };
  return post(`${AUTH_BASE_ENDPOINT}/v1/password/forgot`, body, {
    headers: {
      'x-csrf-token': csrf
    }
  })
    .then(response => {
      return {
        meta: {
          status: 'success'
        },
        data: response
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error
        },
        data: {}
      };
    });
};

const verifyPasswordToken = ({
  email = '',
  token = '',
  csrf = '',
  password = ''
}) => {
  let body = {};
  if (!password) {
    body = { email, token };
  } else {
    body = { password };
  }
  return post(`${AUTH_BASE_ENDPOINT}/v1/password/token`, body, {
    headers: {
      'x-csrf-token': csrf
    }
  })
    .then(response => {
      return {
        meta: {
          status: 'success'
        },
        data: response
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error
        },
        data: {}
      };
    });
};

const updateNewPassword = ({ password = '', csrf = '' }) => {
  const body = { password };
  return patch(`${AUTH_BASE_ENDPOINT}/v1/password`, body, {
    headers: {
      'x-csrf-token': csrf
    }
  })
    .then(response => {
      return {
        meta: {
          status: 'success'
        },
        data: response
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error
        },
        data: {}
      };
    });
};

const fetchProfile = ({ csrf = '' }) => {
  return get(`${AUTH_BASE_ENDPOINT}/v1/profile`, {
    headers: {
      'x-csrf-token': csrf
    }
  })
    .then(response => {
      return {
        meta: {
          status: 'success'
        },
        data: response.data.data
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error
        },
        data: {}
      };
    });
};

const updateProfile = ({
  name = '',
  csrf = '',
  birthdate = '',
  gender = '',
  location = '',
  token = '',
  phone = ''
}) => {
  const body = { name, birthdate, gender, location, token, phone };
  return patch(`${AUTH_BASE_ENDPOINT}/v1/profile`, body, {
    headers: {
      'x-csrf-token': csrf
    }
  })
    .then(response => {
      return {
        meta: {
          status: 'success'
        },
        data: response
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error
        },
        data: {}
      };
    });
};

export default {
  emailForgotPassword,
  verifyPasswordToken,
  updateNewPassword,
  fetchProfile,
  updateProfile,
  getQRCodeClientInfo,
  postQrCodeLogin
};
